var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.81 272.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#006838;}.cls-2{fill:#5eb546;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tobi"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 7.79,
    width: 210.81,
    height: 264.26,
    rx: 11.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 210.81,
    height: 264.26,
    rx: 11.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.87,208.73a15.93,15.93,0,0,1-11.8-5.2l-55.49-60.6a16,16,0,0,1,0-21.61l55.49-60.6a16,16,0,0,1,23.6,21.62L79.08,132.13l45.59,49.79a16,16,0,0,1-11.8,26.81Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset11);
export default __webpack_public_path__ + "static/media/asset11.ab2a3b63765e201835957d038c63fb68.svg";
export { ForwardRef as ReactComponent };